import { useRecordContext, WithRecord } from "ra-core";
import { TextField } from "@/components/admin/text-field";
import type { Contact } from "../types";

export const ContactBackgroundInfo = () => {
  const record = useRecordContext<Contact>();
  if (!record) return null;

  return (
    <div>
      <WithRecord<Contact>
        render={(record) =>
          record?.background ? (
            <div className="text-sm">
              <TextField source="background" record={record} />
            </div>
          ) : null
        }
      />
    </div>
  );
};
